import React from 'react';
import { OutlinedIcon } from '../../index';

import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';

export interface AddToCartFavoriteProps {
    favSelected: boolean,
    setFavorite: Function
}

export const AddToCartFavorite = ({ ...props }: AddToCartFavoriteProps) => {
    return (
        <span className="fav-icon">
            <OutlinedIcon selected={props.favSelected} onClick={() => props.setFavorite()} tooltipText="Add to List" icon={<FavoriteIcon/>} outlinedIcon={<FavoriteBorderIcon/>}/>
        </span>
    );
}